import { AppState } from '../../types/store';

export const getHasOrders = (state: AppState) =>
  state.studio?.orders?.hasOrders ?? false;
